import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useTranslation } from 'react-i18next';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const scrollToSection = (sectionId: string) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-surface-variant backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          
          {/* Logo */}
          <div className="flex items-center">
            <span 
              onClick={scrollToTop}
              className="text-2xl font-bold bg-gradient-cyber bg-clip-text text-transparent cursor-pointer hover:opacity-80 transition-opacity"
            >
              Belada.at
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <div className="flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('services')}
                className="text-muted-foreground hover:text-cyber-blue transition-colors"
              >
                {t('nav.services')}
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-muted-foreground hover:text-cyber-green transition-colors"
              >
                {t('nav.about')}
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-muted-foreground hover:text-cyber-purple transition-colors"
              >
                {t('nav.contact')}
              </button>
            </div>
            
            <div className="flex items-center gap-4">
              <LanguageSwitcher />
              <Button 
                size="sm" 
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-cyber text-primary-foreground hover-glow border-0"
              >
                {t('nav.contact')}
              </Button>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-4">
            <LanguageSwitcher />
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsOpen(!isOpen)}
              className="text-foreground"
            >
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 space-y-2 border-t border-surface-variant">
            <button 
              onClick={() => scrollToSection('services')}
              className="block w-full text-left px-4 py-2 text-muted-foreground hover:text-cyber-blue transition-colors"
            >
              {t('nav.services')}
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-4 py-2 text-muted-foreground hover:text-cyber-green transition-colors"
            >
              {t('nav.about')}
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-4 py-2 text-muted-foreground hover:text-cyber-purple transition-colors"
            >
              {t('nav.contact')}
            </button>
            <div className="px-4 pt-2">
              <Button 
                size="sm" 
                onClick={() => scrollToSection('contact')}
                className="w-full bg-gradient-cyber text-primary-foreground hover-glow border-0"
              >
                {t('nav.contact')}
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;